import { render, staticRenderFns } from "./integratedbusinessmanagerSystem.vue?vue&type=template&id=d5ff1d08&scoped=true"
import script from "./integratedbusinessmanagerSystem.vue?vue&type=script&lang=js"
export * from "./integratedbusinessmanagerSystem.vue?vue&type=script&lang=js"
import style0 from "./integratedbusinessmanagerSystem.vue?vue&type=style&index=0&id=d5ff1d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ff1d08",
  null
  
)

export default component.exports